module.exports = __webpack_public_path__ + "static/media/16b-02_ST-2016-125x95cm-oleo-sobre-papel.f1185815.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16b/16b-02_ST-2016-125x95cm-oleo-sobre-papel.jpg
// module id = 189
// module chunks = 0